export const parseContent = (target: string, vars: string[]): string => {
  return vars.reduce((accumulator, currentValue, index) => {
    return accumulator.replace(`$\{${index}}`, currentValue);
  }, target);
};
